import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useExpenseStore } from "../store";

export const createExpenseType = ({ churchId, expenseTypeData }) => {
  return axios.post(`/churches/${churchId}/expense-types`, expenseTypeData);
};

export const useCreateExpenseType = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeCreateExpenseTypeModal =
    useExpenseStore.getState().closeCreateExpenseTypeModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("expense-types");

      setNotification({
        type: "success",
        message: "Expense type created successfully!"
      });

      closeCreateExpenseTypeModal();
    },
    ...config,
    mutationFn: createExpenseType
  });
};
